import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Hero from './components/Hero';
import ShippingBanner from './components/ShippingBanner';
import ExitIntentOffer from './components/ExitIntentOffer';
import DropSection from './components/DropSection';
import ProductSection from './components/ProductSection';
import Reviews from './components/Reviews';
import Features from './components/Features';
import Community from './components/Community';
import Faq from './components/Faq';
import Footer from './components/Footer';
import PaymentSuccess from './components/pages/PaymentSuccess';
import PaymentCancel from './components/pages/PaymentCancel';
import Admin from './components/pages/Admin';
import LegalPage from './components/pages/LegalPage';
import { Toaster } from 'sonner';
import { MetaNavigationPageViews } from './analytics/MetaNavigationPageViews';
import { MarketingConsent } from './components/MarketingConsent';
import Maintenance from './components/pages/Maintenance';

const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

const Landing = () => (
  <>
    <Header />
    <main>
      <Hero />
      <ShippingBanner />
      <DropSection />
      <ProductSection />
      <Reviews />
      <Features />
      <Community />
      <Faq />
    </main>
    <Footer />
    <ExitIntentOffer />
  </>
);

function App() {
  useEffect(() => {
    document.title = 'WEARHOUSE 60 — WEAR IT OR DIE FOR IT';
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <MetaNavigationPageViews />
          <Routes>
            <Route path="/" element={maintenanceMode ? <Maintenance /> : <Landing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/mentions-legales" element={maintenanceMode ? <Maintenance /> : <LegalPage slug="mentions-legales" />} />
            <Route path="/cgv" element={maintenanceMode ? <Maintenance /> : <LegalPage slug="cgv" />} />
            <Route path="/confidentialite" element={maintenanceMode ? <Maintenance /> : <LegalPage slug="confidentialite" />} />
            <Route path="/retours" element={maintenanceMode ? <Maintenance /> : <LegalPage slug="retours" />} />
            <Route path="/livraison" element={maintenanceMode ? <Maintenance /> : <LegalPage slug="livraison" />} />
            <Route path="*" element={<Maintenance />} />
          </Routes>
        </BrowserRouter>
        {!maintenanceMode && <MarketingConsent />}
        <Toaster />
      </CartProvider>
    </div>
  );
}

export default App;
